import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, PRICE, PRODUCT } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="ultima-pregunta" className="bg-cream" data-id="element-55" data-mp="c8c21b44epg7">
      <div className="mx-auto max-w-3xl px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-56" data-mp="84xkuh4g4316">
        <Reveal data-id="element-57" data-mp="m4ots3g3ut8b">
          <h2 id="ultima-pregunta" className="font-display text-lg font-black uppercase leading-tight text-ink sm:text-2xl" data-id="element-58" data-mp="m46pqkn7bapu">
            Una última pregunta
          </h2>
          <p className="mx-auto mt-1.5 max-w-2xl font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-59" data-mp="vtq8lqawz4kp">
            Dentro de unas semanas puedes seguir guardando videos, descargando
            aplicaciones y tratando de descubrir por tu cuenta qué aprender
            primero...{' '}
            <span className="font-bold text-ink" data-id="element-60" data-mp="zx4qkmiexv0s">
              O puedes comenzar hoy siguiendo una ruta que va desde Hangul hasta
              tus primeras frases y comprensión inicial del coreano.
            </span>
          </p>
          <p className="mt-1.5 font-script text-2xl leading-tight text-coral sm:text-3xl" data-id="element-61" data-mp="2h49hzt8qqjth">
            No necesitas saber coreano para comenzar. Necesitas saber qué
            aprender primero.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-3 rounded-2xl border-2 border-coral bg-white p-3.5 sm:p-5" data-id="element-62" data-mp="2qzkqvuxgwwtb">
          <h3 className="font-display text-base font-black uppercase leading-tight text-ink sm:text-2xl" data-id="element-63" data-mp="3023syctfj5ei">
            {PRODUCT}
          </h3>
          <p className="mt-0.5 text-[0.68rem] font-extrabold uppercase tracking-[0.1em] text-slate sm:text-[0.74rem]" data-id="element-64" data-mp="34u3vmd0vwces">
            Hangul • Pronunciación • Vocabulario • Frases • Vida Real •
            Comprensión
          </p>
          <p className="mt-1.5 font-display text-base font-black uppercase text-coral sm:text-xl" data-id="element-65" data-mp="3it39cpmuz6w6">
            6 Tomos + 5 Bonos incluidos
          </p>
          <p className="mt-1.5 text-[0.72rem] font-bold uppercase text-slate sm:text-[0.78rem]" data-id="element-66" data-mp="1jp4vxveuv9pz">
            🎁 Valor de los bonos:{' '}
            <span className="line-through decoration-coral decoration-2" data-id="element-67" data-mp="1enfi68090hy7">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="text-[0.74rem] font-extrabold uppercase text-coral sm:text-[0.8rem]" data-id="element-68" data-mp="1npoqqsbyi18y">
            🔥 Hoy los 5 bonos: Gratis
          </p>

          <p className="mt-2.5 text-[0.66rem] font-bold uppercase tracking-[0.24em] text-slate sm:text-[0.72rem]" data-id="element-69" data-mp="22gxo5nm3oqwn">
            Precio especial:
          </p>
          <p className="font-display text-4xl font-black leading-none text-ink sm:text-5xl" data-id="element-70" data-mp="2bfsrmrxrfmw9">
            {PRICE}
          </p>
          <p className="text-[0.66rem] font-semibold uppercase tracking-wide text-slate sm:text-[0.72rem]" data-id="element-71" data-mp="27efmyl6elpqx">
            Pago único • Acceso Digital
          </p>

          <div className="mt-3 flex flex-col items-center gap-1.5" data-id="element-72" data-mp="d0ogtvna9o08">
            <CtaButton size="lg" data-id="element-73" data-mp="2vybdfso81r9">🔥 COMIENZA HOY</CtaButton>
            <CtaButton size="lg" data-id="element-74" data-mp="2whuv0xyyy7e">
              ¡SÍ! QUIERO EL SISTEMA COMPLETO POR {PRICE}
            </CtaButton>
            <p className="text-[0.66rem] font-semibold uppercase tracking-wide text-slate sm:text-[0.72rem]" data-id="element-75" data-mp="6ws2ei1etwod">
              Acceso Inmediato • Entrega Digital
            </p>
            <p className="flex items-center gap-1.5 text-[0.66rem] font-bold uppercase tracking-wide text-slate sm:text-[0.72rem]" data-id="element-76" data-mp="3u9cgr1probsx">
              <ShieldCheckIcon size={13} className="text-gold" data-id="element-77" data-mp="3ffhbe5otl4mh" />
              🛡️ Garantía de Devolución de 30 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}